module.exports = __webpack_public_path__ + "img/hotpicklotto_red_and_black.09153c61.png";